<script>
    import Svgo from "./svgo.svelte";
</script>

<Svgo {...$$props} on:click>
    <g fill="none" stroke-width="1.5" stroke="currentColor"> 
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v18m9-9H3" />
    </g>
</Svgo>